import { render, staticRenderFns } from "./AppPermissionSettings.vue?vue&type=template&id=992cb130&scoped=true&"
import script from "./AppPermissionSettings.vue?vue&type=script&lang=js&"
export * from "./AppPermissionSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppPermissionSettings.vue?vue&type=style&index=0&id=992cb130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992cb130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('992cb130')) {
      api.createRecord('992cb130', component.options)
    } else {
      api.reload('992cb130', component.options)
    }
    module.hot.accept("./AppPermissionSettings.vue?vue&type=template&id=992cb130&scoped=true&", function () {
      api.rerender('992cb130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/AppPermissionSettings.vue"
export default component.exports